'use client'

import { FC } from 'react'
import { DateTime } from 'luxon'
import { useCustomRouter } from '@/root/shared-hooks'
import { CalendarIcon } from '@/root/ui/tuuleliinid/icons/CalendarIcon'
import { ClockIcon } from '@/root/ui/shared/icons/ClockIcon'
import { RoundTripIcon } from '@/root/ui/shared/icons/RoundTripIcon'

interface TripRowProps {
  locale: string
  routeFrom: string
  routeTo: string
  timestamp: string
}

const TripRow: FC<TripRowProps> = ({ routeFrom, routeTo, timestamp, locale }) => {
  const dt = DateTime.fromISO(timestamp).setLocale(locale)
  const date = dt.toFormat('ccc dd.MM.yyyy')
  const time = dt.toFormat('HH:mm')

  return (
    <div className="flex flex-col gap-2">
      <p className="text-primary-base text-lg leading-none font-medium">
        {routeFrom} – {routeTo}
      </p>
      <div className="text-primary-base flex items-center gap-2 text-lg leading-none font-medium">
        <CalendarIcon width={15} height={15} color="primary-base" />
        <span>{date}</span>
      </div>
      <div className="text-primary-base flex items-center gap-2 text-lg leading-none font-medium">
        <ClockIcon width={15} height={15} color="primary-base" />
        <span>{time}</span>
      </div>
    </div>
  )
}

interface TripInfoSummaryProps {
  routeFrom: string
  routeTo: string
  timestamp: string
  timestampBack?: string
}

export const TripInfoSummary: FC<TripInfoSummaryProps> = ({ routeFrom, routeTo, timestamp, timestampBack }) => {
  const { locale } = useCustomRouter()

  return (
    <div className="flex flex-col">
      <TripRow routeFrom={routeFrom} routeTo={routeTo} timestamp={timestamp} locale={locale} />
      {timestampBack && (
        <>
          <div className="my-7 w-fit">
            <RoundTripIcon width={40} color="primary-base" />
          </div>
          <TripRow routeFrom={routeTo} routeTo={routeFrom} timestamp={timestampBack} locale={locale} />
        </>
      )}
    </div>
  )
}
